class GoogleMapsLoader {
    constructor() {
        if (GoogleMapsLoader._instance) {
            console.warn("already created!");
            return GoogleMapsLoader._instance;
        }

        GoogleMapsLoader._instance = this;
        GoogleMapsLoader._google = null;
    }

    static instance() {
        if (!GoogleMapsLoader._instance) {
            return new GoogleMapsLoader();
        }

        return GoogleMapsLoader._instance;
    }

    load() {
        if (GoogleMapsLoader._google) {
            return GoogleMapsLoader._google;
        }
        (g => {
            var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__",
                m = document, b = window;
            b = b[c] || (b[c] = {});
            var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams,
                u = () => h || (h = new Promise(async (f, n) => {
                    await (a = m.createElement("script"));
                    e.set("libraries", [...r] + "");
                    for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]);
                    e.set("callback", c + ".maps." + q);
                    a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
                    d[q] = f;
                    a.onerror = () => h = n(Error(p + " could not load."));
                    a.nonce = m.querySelector("script[nonce]")?.nonce || "";
                    m.head.append(a);
                }));
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) :
                d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n));
        })({
            key: window.env?.GOOGLE_API_KEY,
            v: "weekly",
        });

        GoogleMapsLoader._google = google;

        return GoogleMapsLoader._google;
    }

    get google() {
        return GoogleMapsLoader._google;
    }

    async importLibrary(type) {
        await this.google.maps.importLibrary(type);
    }

}

GoogleMapsLoader._instance = null;
GoogleMapsLoader._google = null;

export default GoogleMapsLoader;